// TODO move it to utils package
export const JPG = 'image/jpeg' as const;
export const PNG = 'image/png' as const;
export const PDF = 'application/pdf' as const;
export const GIF = 'image/gif' as const;
export const DOC = 'application/msword' as const;
export const DOCX =
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document' as const;

export const FILE_TYPES = [JPG, PNG, PDF, DOC, GIF, DOCX];

export const FILE_EXTENSIONS = {
    [DOC]: 'DOC',
    [DOCX]: 'DOCX',
    [PDF]: 'PDF',
};
export const MAX_FILE_SIZE = 5242880;

export const CODE_FILE_UNDEFINED_ERROR = 0 as const;
export const CODE_FILE_SIZE_ERROR = 1 as const;
export const CODE_FILE_TYPE_ERROR = 2 as const;
